// eslint-disable-next-line import/prefer-default-export
export var mapSEOandGovernmentLocalities = function mapSEOandGovernmentLocalities(locality) {
  var exceptions = [['13000-MARSEILLE', '13001-MARSEILLE'], ['69000-LYON', '69001-LYON'], ['75000-PARIS', '75001-PARIS']];

  for (var _i = 0, _exceptions = exceptions; _i < _exceptions.length; _i++) {
    var couple = _exceptions[_i];
    if (couple.includes(locality)) return couple;
  }

  return [locality, locality];
};
//# sourceMappingURL=seoLocalities.js.map